import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Caution } from "@air/next-icons";
import { Banner } from "@air/primitive-banner";
import { useFormikContext } from "formik";
import { useCallback } from "react";
import { useHotkeys } from "react-hotkeys-hook";
import { DimensionBar } from "~/components/DimensionBar/DimensionBar";
import { ExportImageExtSelect } from "~/components/ExportImagesModal/components/ExportImagesModalForm/ExportImageExtSelect";
import { ExportImageSizeSelect } from "~/components/ExportImagesModal/components/ExportImagesModalForm/ExportImageSizeSelect";
import { ImageSuffixFormField } from "./components/ImageSuffixFormField";
export const ExportImagesModalForm = (param)=>{
    let { exportImage, imageProcessingError, isEditing, setIsEditing, setIsExportDisabled } = param;
    const { values } = useFormikContext();
    const keyboardHandler = useCallback(()=>exportImage(values), [
        exportImage,
        values
    ]);
    useHotkeys("enter", keyboardHandler, {
        enableOnFormTags: [
            "INPUT"
        ],
        enabled: !isEditing
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex justify-between pb-4",
                children: /*#__PURE__*/ _jsx(ExportImageSizeSelect, {
                    setIsEditing: setIsEditing
                })
            }),
            /*#__PURE__*/ _jsx(DimensionBar, {
                onError: setIsExportDisabled,
                setIsEditing: setIsEditing,
                className: "mb-2"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-col justify-end",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "flex justify-between",
                    children: [
                        /*#__PURE__*/ _jsx(ImageSuffixFormField, {
                            setIsEditing: setIsEditing
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "ml-4 shrink-0",
                            children: /*#__PURE__*/ _jsx(ExportImageExtSelect, {
                                setIsEditing: setIsEditing
                            })
                        })
                    ]
                })
            }),
            imageProcessingError && /*#__PURE__*/ _jsx(Banner, {
                className: "mt-4 items-center",
                appearance: "danger",
                prefix: /*#__PURE__*/ _jsx(Caution, {
                    className: "size-4"
                }),
                children: /*#__PURE__*/ _jsx("p", {
                    children: "Error: File cannot be processed."
                })
            })
        ]
    });
};
